import Cookies from 'js-cookie';

export const getCookie = (cookieName: string) => {
  return Cookies.get(cookieName);
};

export const deleteCookie = (cookieName: string) => {
  Cookies.set(cookieName, '', { domain: window.location.hostname, expires: -1 });
  Cookies.remove(cookieName);
  Cookies.remove(cookieName, { path: '', domain: '.healiospace.com' });
  Cookies.remove(cookieName, { path: '/', domain: '.healiospace.com' });
};

export const setCookie = (cookieName: string, cookieValue: string, expiryTime: number) => {
  Cookies.set(cookieName, cookieValue, { domain: window.location.hostname, expires: expiryTime });
};
